import { Component, OnInit, EventEmitter } from '@angular/core';
import { SessionService, TableColumns, TableConfiguration, MenuBreadCrumb } from 'brainloper-ui';
import { MatDialog } from '@angular/material/dialog';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { DeleteGenericService } from 'app/services/delete-generic.service';
import { DisabilitiesDetailComponent } from './disabilities-detail/disabilities-detail.component';
import { Disabilities } from 'app/models2/human-resources/disabilities';


@Component({
  selector: 'app-disabilities',
  templateUrl: './disabilities.component.html',
  styleUrls: ['./disabilities.component.scss']
})
export class DisabilitiesComponent implements OnInit {
  public urlGetIncapacidades: string = `${EndpointDictionary.Disabilities.DISABILITIES_TABLE}`;

  public titleIncapacidades: string = screen.width<500?'':'Incapacidades'

  public recargarTablaIncapacidades = new EventEmitter<any>()
  public configurationIncapacidades: TableConfiguration = {
    edit: false,
    add: true,
    delete: false,
    selectable: false,
    addPer: true,
    editPer: false,
    primaryKey: 'id',
    view: true

  }
  public columnasIncapacidades: TableColumns<Disabilities>[] = [
    {
      ID: 'user',
      label: 'Usuario',
      type: 'number',
      style: {
        textAlign: 'center',
        movil:'no-movil'
      },
    },
    {
      ID: 'userName',
      label: 'Nombre',
      type: 'string',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'disabilityType',
      label: 'Tipo Incapacidad',
      type: 'string',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'startDate',
      label: 'Fecha inicio',
      type: 'fecha',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'duration',
      label: 'Duración',
      type: 'string',
      style: {
        textAlign: 'center',
        movil:'no-movil'
      },
    }
  ]

  public menuBreadCrumb:Array<MenuBreadCrumb> = [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
    name:"Incapacidades",
    current:true
  }]

  constructor(
    private session: SessionService,
    public dialog: MatDialog,
    public deleteItem: DeleteGenericService
  ) { }

  ngOnInit(): void {
  }

  agregarIncapacidades($event) {
    //console.log($event)
    this.session.setData('redireccion', 'nuevo')
    let size = screen.width > 1000 ? 90 : 90

    this.dialog.open(DisabilitiesDetailComponent, {
      width: `${size}%`,
      height: `${size}%`,
      data: ''

    }).afterClosed().subscribe(res=>{
      this.recargarTablaIncapacidades.emit()
    })
  }

  editarIncapacidades($event) {
    //console.log($event)
  }

  async eliminarIncapacidades($event) {
    //console.log($event)
    // let res =  await this.deleteItem.deleteD($event, this.urlDeleteIncapacidades, "id", "Icapacidad", "Incapacidades")
    //       this.recargarTablaIncapacidades.emit()
  }

  seleccionadosIncapacidades($event) {
    //console.log($event)
  }

  viewDisabilitie($event:Disabilities[]) {
    //console.log($event)
    this.session.setData('redireccion', 'visualizar')
    let size: number = screen.width > 1000 ? 80 : 90

    this.dialog.open(DisabilitiesDetailComponent, {
      width: `${size}%`,
      height: `${size}%`,
      data: $event[0]

    })
  }

}
